var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { LocalStorageService } from './LocalStorageService';
var SharePointService = (function () {
    //private logger: DebugLogging; //used to set up logging
    function SharePointService(properties) {
        //this.logger = new DebugLogging();
        //this.logger.enableLog = false; //default to not enable log
        if (properties === void 0) { properties = {}; }
        this.localStorageKeyName = "SP"; //constant - may not be changed
        this.localStorageKeyPrefix = "TD"; //constant - may not be changed
        this.useLocalStorage = true; //default to always use local storage
        this.localStorageTimeout = 30; //default to 30 minutes
        if (properties) {
            if (typeof properties.useLocalStorage != "undefined") {
                this.useLocalStorage = properties.useLocalStorage;
            }
            if (typeof properties.localStorageTimeout != "undefined") {
                this.localStorageTimeout = properties.localStorageTimeout;
            }
            if (typeof properties.enableLog != "undefined") {
                //this.logger.enableLog = properties.enableLog;
            }
        }
    }
    /**
     * Attempt a SP get request based on the URL provided
     * @param url the url to retrieve data from, i.e. the list URL
     * @return any - the found and validated local storage value
     */
    SharePointService.prototype.get = function (url, validateSPResponse) {
        if (validateSPResponse === void 0) { validateSPResponse = true; }
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var p;
            return __generator(this, function (_a) {
                p = new Promise(function (resolve, reject) { return __awaiter(_this, void 0, void 0, function () {
                    var response, localStorageService, localStorageKeyValue, err_1, err_2;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                response = null;
                                localStorageService = new LocalStorageService();
                                localStorageKeyValue = {
                                    keyName: this.localStorageKeyName + url,
                                    keyPrefix: this.localStorageKeyPrefix,
                                    timeOutInMinutes: this.localStorageTimeout
                                };
                                if (!(this.useLocalStorage && this.localStorageTimeout > 0)) return [3 /*break*/, 4];
                                _a.label = 1;
                            case 1:
                                _a.trys.push([1, 3, , 4]);
                                return [4 /*yield*/, localStorageService.get(localStorageKeyValue)];
                            case 2:
                                // this.logger.log("SharePointService.get: local storage requested for " + localStorageKeyValue.keyName);
                                response = _a.sent();
                                //do not return yet as may need to get a specific key value
                                if (response) {
                                    resolve(response);
                                }
                                return [3 /*break*/, 4];
                            case 3:
                                err_1 = _a.sent();
                                //ensure that context is set back to null
                                response = null;
                                return [3 /*break*/, 4];
                            case 4:
                                if (!!response) return [3 /*break*/, 12];
                                _a.label = 5;
                            case 5:
                                _a.trys.push([5, 11, , 12]);
                                return [4 /*yield*/, this.sendGetRequest(url, validateSPResponse)];
                            case 6:
                                //go and get all profile props
                                response = _a.sent();
                                if (!response) return [3 /*break*/, 9];
                                if (!this.useLocalStorage) return [3 /*break*/, 8];
                                //set up local storage object to attempt to get data
                                localStorageKeyValue.keyValue = response;
                                //store to local storage
                                return [4 /*yield*/, localStorageService.set(localStorageKeyValue)];
                            case 7:
                                //store to local storage
                                _a.sent();
                                _a.label = 8;
                            case 8:
                                resolve(response);
                                return [3 /*break*/, 10];
                            case 9:
                                //this.logger.log("SharePointContext.get: error - no context provided by spweb");
                                reject("emptySharePointResponse");
                                _a.label = 10;
                            case 10: return [3 /*break*/, 12];
                            case 11:
                                err_2 = _a.sent();
                                //ensure that myProperties is set back to null
                                response = null;
                                // this.logger.log("SharePointService.get: an error occurred retrieving context");
                                // this.logger.log(err);
                                reject("invalidSharePointGetRequest");
                                return [3 /*break*/, 12];
                            case 12: return [2 /*return*/];
                        }
                    });
                }); });
                return [2 /*return*/, p];
            });
        });
    };
    /**
     * Attempt a SP get request page by page based on the URL provided
     * @param url the url to retrieve data from, i.e. the list URL
     * @return any - result items
     */
    SharePointService.prototype.getPagedResults = function (queryUrl, previousPageData) {
        if (previousPageData === void 0) { previousPageData = []; }
        return __awaiter(this, void 0, void 0, function () {
            var spResponse;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.get(queryUrl)];
                    case 1:
                        spResponse = _a.sent();
                        previousPageData.push.apply(previousPageData, spResponse.results);
                        if (spResponse.__next) {
                            return [2 /*return*/, this.getPagedResults(spResponse.__next, previousPageData)];
                        }
                        else {
                            return [2 /*return*/, Promise.resolve(previousPageData)];
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * make an actual REST request to sharepoint url provided
     * @param url the url to retrieve data from, i.e. the list URL
     * @param boolean if true (default), SharePoint data will be processed. If false, we just want the data (external txt file in json format)
     * @return any - the sharepoint raw response
     */
    SharePointService.prototype.sendGetRequest = function (url, validateSPResponse) {
        if (validateSPResponse === void 0) { validateSPResponse = true; }
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                // console.log("SharePointService.sendGetRequest: started");
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        var req = new XMLHttpRequest();
                        req.open('GET', url);
                        //req.responseType="json";
                        //contentType: "application/json;odata=verbose",
                        req.setRequestHeader("accept", "application/json;odata=verbose");
                        req.onload = function () {
                            if (req.status >= 200 && req.status <= 299) {
                                // console.log("SharePointService.sendGetRequest: response");
                                //console.log(req);
                                if (validateSPResponse) {
                                    var data = JSON.parse(req.response);
                                    //we require valid json returned, with "d" key
                                    if (data && data.d) {
                                        resolve(data.d);
                                    }
                                    else {
                                        // console.log("SharePointService.sendGetRequest: error:");
                                        // console.log(req);
                                        reject("invalidSPRestResponse");
                                    }
                                }
                                else {
                                    resolve(req.response);
                                }
                            }
                            else {
                                reject(req.statusText);
                            }
                        };
                        req.onerror = function () {
                            reject("Network Error: " + req.statusText);
                        };
                        req.send();
                    })];
            });
        });
    };
    SharePointService.prototype.createListItem = function (siteURL, listName, itemData) {
        return __awaiter(this, void 0, void 0, function () {
            var listItemEntityTypeFullName, spResponse;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getListItemEntityTypeFullName(siteURL + "/_api/web/lists/GetByTitle('" + listName + "')")];
                    case 1:
                        listItemEntityTypeFullName = _a.sent();
                        // console.log("after await - got listItemEntityTypeFullName:");
                        // console.log(listItemEntityTypeFullName);
                        // add metadata to itemData
                        itemData.__metadata = { "type": listItemEntityTypeFullName };
                        return [4 /*yield*/, this.sendPostRequest(siteURL + "/_api/web/lists/GetByTitle('" + listName + "')/items", itemData)];
                    case 2:
                        spResponse = _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    // TODO: public updateListItem
    // look up ETag: https://docs.microsoft.com/en-us/sharepoint/dev/sp-add-ins/working-with-lists-and-list-items-with-rest#using-etag-values-to-determine-document-and-list-item-versioning
    // TODO: public deleteListItem
    SharePointService.prototype.getListItemEntityTypeFullName = function (url) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                // take URL of list
                // return ListItemEntityTypeFullName
                // console.log("inside getListItemEntityTypeFullName");
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        var req = new XMLHttpRequest();
                        req.open('GET', url + '?$select=ListItemEntityTypeFullName');
                        req.setRequestHeader("accept", "application/json;odata=verbose");
                        req.onload = function () {
                            if (req.status >= 200 && req.status <= 299) {
                                // console.log("SharePointService.sendPostRequest: response");
                                // console.log(req);
                                var data = JSON.parse(req.response);
                                // console.log(data.d.ListItemEntityTypeFullName);
                                resolve(data.d.ListItemEntityTypeFullName);
                            }
                            else {
                                reject(req.statusText);
                            }
                        };
                        req.onerror = function () {
                            reject("Network Error: " + req.statusText);
                        };
                        // console.log("req:");
                        // console.log(req);
                        req.send();
                    })];
            });
        });
    };
    /**
     * post an actual REST request to sharepoint url provided
     * @param url the url to send data to, i.e. the list API URL with /items
     * @return any - the sharepoint raw response
     */
    SharePointService.prototype.sendPostRequest = function (url, data) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                // console.log("SharePointService.sendPostRequest: started");
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        var req = new XMLHttpRequest();
                        var requestDigest = document.getElementById("__REQUESTDIGEST").getAttribute("value");
                        var postData = JSON.stringify(data);
                        req.open('POST', url);
                        //req.responseType="json";
                        //contentType: "application/json;odata=verbose",
                        req.setRequestHeader("Content-Type", "application/json;odata=verbose");
                        req.setRequestHeader("accept", "application/json;odata=verbose");
                        req.setRequestHeader("X-RequestDigest", requestDigest);
                        req.onload = function () {
                            if (req.status >= 200 && req.status <= 299) {
                                // console.log("SharePointService.sendPostRequest: response");
                                // console.log(req);
                                resolve(req);
                            }
                            else {
                                reject(req.statusText);
                            }
                        };
                        req.onerror = function () {
                            reject("Network Error: " + req.statusText);
                        };
                        // console.log("req:");
                        // console.log(req);
                        req.send(postData);
                    })];
            });
        });
    };
    return SharePointService;
}());
export { SharePointService };

//# sourceMappingURL=SharePointService.js.map
